module.exports = __webpack_public_path__ + "static/img/squad_template_white.5d668e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/squad_template_white.png
// module id = EdnS
// module chunks = 79